import React, { useState, useCallback, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import IssueType from './IssuerTypes'
import IssuerStep2 from './IssuerStep2'
import IssuerPublish from './IssuerPublish'
import Loader from '../../../components/Loader';
import BulkUpload from './BulkUpload';
import useRefreshToken from '../../../Hooks/usegenerateToken';
import { BASE_URL, USER_TOKEN } from '../../../Utils/constant';
import SelectIssueDoc from './SelectIssueDoc';
import { DocumentDetails } from './Issuer/DocumentDetails';

export default function IssueCredentials({ ISSUER_ID }) {
  useRefreshToken(BASE_URL + USER_TOKEN)
  const location = useLocation()
  const [step, setStep] = useState(1)
  const [doc, setDoc] = useState({})
  const [loading, setLoading] = useState(true)

  const navigate = useNavigate();

  const updateLocationState = () => {
    const newState = { ...location.state };
    if (newState.isNew) {
      let temp = {}
      temp.id = newState.data.details.document_id
      temp.issuer_id = newState.data.details.issuer_id
      temp.doc_name = newState.data.details.document_name
      temp.updated_at = newState.data.details.updated_at
      setDoc(temp)
      setStep(newState.step)
      newState.isNew = false
      navigate(location.pathname, { state: newState });
    }
    else if (newState.step) {
      setDoc(newState.data)
      setStep(newState.step)
      newState.isNew = false
      navigate(location.pathname, { state: newState });
    }
    setLoading(false)

  };

  const handleStep = useCallback((s) => {
    setStep(s)
  }, []);

  useEffect(() => {
    updateLocationState()
  }, [])

  return (
    <>
      {loading ? (
        <Loader isOpen />
      ) : (
        <>
          {(() => {
            switch (step) {
              case 1:
                return <SelectIssueDoc ISSUER_ID={ISSUER_ID} handleStep={handleStep} setDoc={setDoc} />;
              case 2:
                return <DocumentDetails ISSUER_ID={ISSUER_ID} handleStep={handleStep} doc={doc} setDoc={setDoc} />;
              case 3:
                return <IssueType ISSUER_ID={ISSUER_ID} handleStep={handleStep} doc={doc} />;
              case 4:
                return <IssuerStep2 handleStep={handleStep} doc={doc} />;
              case 5:
                return <IssuerPublish handleStep={handleStep} doc={doc} />;
              case 6:
                return <BulkUpload handleStep={handleStep} doc={doc} />;
              default:
                return null; // Default case to handle invalid `step` values
            }
          })()}
        </>
      )}
    </>
  );

}
